import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import useOrganizationClientRecordBillingDetails from '../../../../../../hooks/api/useOrganizationClientRecordBillingDetails';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import LabelValueDisplay from '../../../../../v2BaseComponents/LabelValueDisplay';

const intl = getIntl('profiles.clientRecordBillingContactDetails', {
    edit: 'Edit',
    name: 'Billing Contact Name',
    email: 'Billing Contact Email',
    phoneNumber: 'Billing Contact Phone Number',
});

export type ClientRecordBillingContactDetailsOwnProps = {
    onEdit: () => void;
    clientRecordId: string;
};

export type ClientRecordBillingContactDetailsProps = ClientRecordBillingContactDetailsOwnProps;

const ClientRecordBillingContactDetails: React.FC<ClientRecordBillingContactDetailsProps> = ({
    clientRecordId,
    onEdit,
}) => {
    const { isLoadingBillingDetails, billingDetails } = useOrganizationClientRecordBillingDetails({
        organizationClientRecordId: clientRecordId,
    });

    return (
        <AnimateLoadedContent isLoading={isLoadingBillingDetails}>
            {() => (
                <ActionButtonLayout
                    actions={[
                        {
                            title: intl('edit'),
                            onPress: onEdit,
                            icon: 'Edit2',
                            testID: 'edit-billing-contact-details-button',
                        },
                    ]}
                >
                    <MainContentContainer>
                        <LabelValueDisplay
                            items={[
                                { label: intl('name'), value: billingDetails?.name || '' },
                                { label: intl('email'), value: billingDetails?.email || '' },
                                { label: intl('phoneNumber'), value: billingDetails?.phoneNumber || '' },
                            ]}
                        />
                    </MainContentContainer>
                </ActionButtonLayout>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(ClientRecordBillingContactDetails);
